import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export const Layout = () => {
  return <div className="min-h-screen flex flex-col bg-[#050810] text-gray-300 font-sans selection:bg-purple-500/30" data-id="element-135">
      <Header data-id="element-136" />
      <main className="flex-grow pt-[72px]" data-id="element-137">
        <Outlet data-id="element-138" />
      </main>
      <Footer data-id="element-139" />
    </div>;
};
export const PageHeader = ({
  title,
  description
}: {
  title: string;
  description?: string;
}) => {
  return <div className="relative py-20 px-4 sm:px-6 lg:px-8 bg-[#0a0e27] border-b border-white/10 overflow-hidden" data-id="element-140">
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-141"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-purple-600/20 blur-[100px] rounded-full pointer-events-none" data-id="element-142"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-143">
        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-6 tracking-tight" data-id="element-144">
          {title}
        </h1>
        {description && <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-145">
            {description}
          </p>}
      </div>
    </div>;
};
export const LegalLayout = ({
  children,
  title,
  lastUpdated
}: {
  children: React.ReactNode;
  title: string;
  lastUpdated?: string;
}) => {
  return <div className="min-h-screen bg-[#050810]" data-id="element-146">
      <PageHeader title={title} description={lastUpdated ? `Last Updated: ${lastUpdated}` : undefined} data-id="element-147" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-148">
        <div className="glass-panel rounded-2xl p-8 md:p-12 prose prose-invert prose-purple max-w-none" data-id="element-149">
          {children}
        </div>
      </div>
    </div>;
};